import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import * as cafeEventsActions from '../../redux/cafeEvents/actions';
import CafeEventsTable from './cafeEventsTable';
import CafeEventFilter from './cafeEventFilter';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import Spin from '../../components/loading';
import Pagination2 from '../../components/Pagination2';
import submitForm from '../../utils/submitForm';
class CafeEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      sortType: 'asc',
      sortBy: 'fromDate',
      itemsPerPage: 10
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      // console.log('filter===>>', searchQuery);
      this.props.fetchAllCafeEvents(searchQuery);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      // console.log('pageNumber is: ', pageNumber);
      // console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, sortType, totalPages, pageLimit } = data;

    // console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCafeEvents(query);
    });
  };

  render() {
    let { cafeEventsLoading, cafeEventsMessage, cafeEventsFailed, cafeEventsError } = this.props;
    let { totalRecords } = this.props.cafeEvents;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.eventsManagement')}</div>
          </h3>
          <div>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_EVENT_REQUEST}>
              <NavLink
                to={{
                  pathname: '/cafe-events/add',
                  editMode: false
                }}
              >
                <button className="btn btn-primary w-5 mx-1">
                  <i className="fal fa-plus mx-1" />
                  {locales('titles.addNewEvent')}
                </button>
              </NavLink>
            </ShowForPermission>
          </div>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={cafeEventsLoading}>
            <article>
              <main className="panel panel-default">
                {cafeEventsError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {cafeEventsFailed && <div className="alert alert-danger">{cafeEventsMessage}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.eventsList')}
                    </div>
                    <div className="panel-body">
                      <CafeEventFilter applyFilters={this.applyFilters} filterAndSort={this.filterAndSort} />
                      <CafeEventsTable
                        pageNumber={currentPage}
                        sortTable={this.sortTable}
                        pageSize={itemsPerPage}
                        sortType={sortType}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeEventsList: state.cafeEventsReducer.cafeEventsList,
    cafeEvents: state.cafeEventsReducer.cafeEvents,
    cafeEventsLoading: state.cafeEventsReducer.cafeEventsLoading,
    cafeEventsMessage: state.cafeEventsReducer.cafeEventsMessage,
    cafeEventsFailed: state.cafeEventsReducer.cafeEventsFailed,
    cafeEventsError: state.cafeEventsReducer.cafeEventsError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeEvents: query => dispatch(cafeEventsActions.fetchAllCafeEvents(query))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CafeEvents));
